'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const navLinks = [
  { href: '/', label: 'Home' },
  { href: '/shop', label: 'Shop' },
  { href: '/about', label: 'About Us' },
  { href: '/contact', label: 'Contact' },
];

interface HeaderProps {
  cartCount?: number;
}

export default function Header({ cartCount = 0 }: HeaderProps) {
  const pathname = usePathname();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activePath, setActivePath] = useState('');

  useEffect(() => {
    setActivePath(pathname);
  }, [pathname]);

  return (
    <header style={{ background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', position: 'sticky', top: 0, zIndex: 50 }}>
      <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 }}>
        {/* Logo */}
        <Link href="/" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }}>
          <div className="hero-gradient shine" style={{ width: 40, height: 40, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 6 2 18 2 18 9" />
              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
              <rect x="6" y="14" width="12" height="8" />
            </svg>
          </div>
          <div>
            <div style={{ fontWeight: 900, color: '#0057b8', fontSize: 18, lineHeight: 1 }}>PRINTMOB HUB</div>
            <div style={{ fontSize: 10, color: '#9ca3af', letterSpacing: '0.1em' }}>DALLAS, TX — PRINTER STORE</div>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav style={{ display: 'flex', gap: 24, fontSize: 14, fontWeight: 600 }} className="hidden md:flex">
          {navLinks?.map((link) => (
            <Link
              key={link?.href}
              href={link?.href}
              style={{
                textDecoration: 'none',
                color: activePath === link?.href ? '#0057b8' : '#374151',
                position: 'relative',
                paddingBottom: 2,
              }}
            >
              {link?.label}
              {activePath === link?.href && (
                <span style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: 2, background: '#00b4d8', borderRadius: 2 }} />
              )}
            </Link>
          ))}
        </nav>

        {/* Right side: Cart + Mobile menu */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Link
            href="/cart"
            style={{
              background: '#005CBB',
              color: '#fff',
              border: 'none',
              padding: '8px 20px',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              textDecoration: 'none',
              transition: 'background .2s',
            }}
          >
            <span>🛒</span>
            <span>Cart</span>
            <span style={{
              background: '#FF6B00',
              color: '#fff',
              borderRadius: 99,
              fontSize: 11,
              fontWeight: 700,
              padding: '1px 7px',
              minWidth: 20,
              textAlign: 'center',
            }}>{cartCount}</span>
          </Link>
          {/* Mobile menu button */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="flex md:hidden"
            style={{ background: 'none', border: 'none', padding: 8, cursor: 'pointer' }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0057b8" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              {mobileOpen ? (
                <><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>
              ) : (
                <><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="18" x2="21" y2="18" /></>
              )}
            </svg>
          </button>
        </div>
      </div>
      {/* Mobile Nav */}
      {mobileOpen && (
        <div style={{ padding: '12px 16px 16px', borderTop: '1px solid #f3f4f6' }}>
          {navLinks?.map((link) => (
            <Link
              key={link?.href}
              href={link?.href}
              onClick={() => setMobileOpen(false)}
              style={{ display: 'block', padding: '8px 0', fontSize: 14, fontWeight: 600, color: activePath === link?.href ? '#0057b8' : '#374151', textDecoration: 'none' }}
            >
              {link?.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
